import i18n from "@/common/lang";
//流量统计
//筛选流量月份数据
export function GetFlowstatisticsYear(List, Year) {
    //筛选出 did+0000000 的数据
    const data = List
        //创建时间数组
    let Time = []
        //创建时间数据
    for (let i = 1; i <= 12; i++) {
      Time.push(i18n.t(`lang.month[${i}]`))
    }
    //返回图表数据与时间数据
    return { data, Time }
}
//筛选流量日期数据
export function GetFlowstatisticsDay(List, month, dayclass) {
    //筛选出 did+0000000 的数据
    const data = List
        //创建时间数组
    let Time = []
        //创建时间数据
        //先给日期排序
    dayclass.sort((a, b) => {
            return a.value - b.value
        }).map((val, index) => {
          let dateString = setDateEglish(val.value)
          Time.push(`${val.value}${dateString}`)
        })
        //返回图表数据与时间数据
    return { data, Time }
}
//筛选流量小时数据
export function GetFlowstatisticsTime(List, day) {
    //筛选出 did+0000000 的数据
    const data = List
        //创建时间数组
    let Time = []
        //创建时间数据
    for (let i = 1; i <= 24; i++) {
        if (i >= 10) {
            Time.push(`${i}${i18n.t('lang.DateSelect.singlehour')}`)
        } else {
            Time.push(`0${i}${i18n.t('lang.DateSelect.singlehour')}`)
        }
    }
    //返回图表数据与时间数据
    return { data, Time }
}
//筛选流量分钟数据
export function GetFlowstatisticsMinute(List, clock) {
    //筛选出 did+0000000 的数据
    const data = List
        //创建时间数组
    let Time = []
        //创建时间数据
    for (let i = 5; i <= 60; i += 5) {
        if (i >= 10) {
            //i等于60时clock+1
            let Clock;
            if (i === 60) {
                if (clock < 9) {
                    Clock = '0' + (Number(clock) + 1)
                } else {
                    Clock = String((Number(clock) + 1))
                }
            }
            Time.push(`${Clock||clock} : ${i===60?'00':i}`)
        } else {
            Time.push(`${clock} : 0${i}`)
        }
    }
    //返回图表数据与时间数据
    return { data, Time }
}
//信号统计
//筛选信号月份数据
export function GetsignalstatisticsYear(year, list, did) {
    //筛选信号数据
    let data = list[`did${did}`]
    data.net3gwan1 = data.net3gwan1.filter(val => val > -1)
    data.net3gwan2 = data.net3gwan2.filter(val => val > -1)
    // 创建时间数组
    let Time = []
    //创建过去信号数据
    for (let i = 0, t = 1, d = 0; i < data.net3gwan1.length; i++) {
        if (d < new Date(year, t, 0).getDate()) {
          if(d === 0) {
            d = d + 1
            Time.push(i18n.t(`lang.month[${t}]`))
            let item1 = data.net3gwan1[i]
            let item2 = data.net3gwan2[i]
            data.net3gwan1[i] = setData(item1)
            data.net3gwan2[i] = setData(item2)
          }else{
            d = d + 1
            let dateString = setDateEglish(d)
            let result = i18n.t(`lang.month[${t}]`) + ' ' + d + dateString
            console.log('dateString');
            Time.push(result)
          }
        } else {
            ++t
            d = 1
            Time.push(i18n.t(`lang.month[${t}]`))
            let item1 = data.net3gwan1[i]
            let item2 = data.net3gwan2[i]
            data.net3gwan1[i] = setData(item1)
            data.net3gwan2[i] = setData(item2)
        }
    }
    return { data, Time }
}
//筛选信号日期数据
export function GetsignalstatisticsDay(month, dayclass, list, did) {
    //筛选数据
    let data = list[`did${did}`]
    data.net3gwan1 = data.net3gwan1.filter(val => val > -1)
    data.net3gwan2 = data.net3gwan2.filter(val => val > -1)
        //创建时间数组
    let Time = []
        //时间排序
    dayclass.sort((a, b) => {
      return a.value - b.value
    })
        //创建时间数据(月份信号每8小时一个值，每天3个点8-16-24)
    for (let i = 0, t = 0; i < ~~data.net3gwan1.length / 3; t === 24 ? i++ : i) {
      let item = ''
      t === 24 ? t = 8 : t += 8
      let dateString = setDateEglish(dayclass[i].value)
      if(t === 8) {
        item = `${dayclass[i].value}${dateString}`
        Time.push(item)
        let index = Time.length - 1
        // 获取当前需要标记的下标数据
        let dataItem1 = data.net3gwan1[index]
        let dataItem2 = data.net3gwan2[index]
        data.net3gwan1[index] = setData(dataItem1)
        data.net3gwan2[index] = setData(dataItem2)
      }else{
        item = `${dayclass[i].value}${dateString} : ${t}${i18n.t(`lang.DateSelect.singlehour`)}`
        Time.push(item)
      }
    }
    return { data, Time }
}
//筛选信号小时数据
export function GetsignalstatisticsTime(list, did) {
    //筛选数据
    let data = list[`did${did}`]
    data.net3gwan1 = data.net3gwan1.filter(val => val > -1)
    data.net3gwan2 = data.net3gwan2.filter(val => val > -1)
        //创建时间数组
    let Time = []
        //创建时间数据(信号数据每天20分钟一个值,每小时20-40-60)
    for (let i = 0, t = 0; i < data.net3gwan1.length / 3; t === 60 ? i++ : i) {
      t === 60 ? t = 20 : t = t + 20
      if(t === 20) {
        if(i< 10) {
          Time.push(`0${i}${i18n.t(`lang.DateSelect.singlehour`)}`)
        }else{
          Time.push(`${i}${i18n.t(`lang.DateSelect.singlehour`)}`)
        }
        let index = Time.length - 1
        let dataItem1 = data.net3gwan1[index]
        let dataItem2 = data.net3gwan2[index]
        data.net3gwan1[index] = setData(dataItem1)
        data.net3gwan2[index] = setData(dataItem2)
      }else{
        if(i< 10) {
          Time.push(`0${i}${i18n.t(`lang.DateSelect.singlehour`)} : ${t}${i18n.t(`lang.DateSelect.singleminute`)}`)
        }else{
          Time.push(`${i}${i18n.t(`lang.DateSelect.singlehour`)} : ${t}${i18n.t(`lang.DateSelect.singleminute`)}`)
        }
      }
    }
    return { data, Time }
}
//筛选信号分钟数据
export function GetsignalstatisticsMinute(clock, list, did) {
    //创建时间数组
    let Time = []
        //筛选数据
    let data = list[`did${did}`]
    data.net3gwan1 = data.net3gwan1.filter(val => val > -1)
    data.net3gwan2 = data.net3gwan2.filter(val => val > -1)
        //创建时间数据(信号数据每小时5分钟一个值)
    for (let i = 5; i <= data.net3gwan1.length * 5; i += 5) {
        //分钟 i===60 小时数clock+1 i='00'
        if (i >= 10) {
            let Clock;
            if (i === 60) {
                if (clock < 9) {
                    Clock = '0' + (Number(clock) + 1)
                } else {
                    Clock = String((Number(clock) + 1))
                }
            }
            Time.push(`${Clock||clock} : ${i===60?'00':i}`)
        } else {
            Time.push(`${clock} : 0${i}`)
        }
    }
    return { data, Time }
}
//筛选在线月份数据
export function GetonlinerateYear(year, list) {
    //创建时间数组
    let Time = []
        //筛选数据
    let data = list
        //筛选日期
    data = data.filter(val => val > -1)
        //添加百分比
    data = data.map(val => parseInt(val * 100))
    // new Date(year, month, day) 获取指定日期对象，month 0~11之间，0:1月，day: 几号，1-31， 1:1号
    // 例如 new Date(2020,8,29) // 返回为2020年8月29号
    for (let i = 0, t = 1, d = 0; i < data.length; i++) {
        if (d < new Date(year, t, 0).getDate()) {
            if(d === 0) {
              d = d + 1
              Time.push(i18n.t(`lang.month[${t}]`))
              let item = data[i]
              data[i] = setData(item)
            }else{
              d = d + 1
              let result = i18n.t(`lang.month[${t}]`) + ' ' + d + setDateEglish(d)
              Time.push(result)
            }         
        } else { 
            ++t
            d = 1
            Time.push(i18n.t(`lang.month[${t}]`))
            let item = data[i]
            data[i] = setData(item)
        }
    }
    return { Time, data }
}
//筛选在线日期数据,dayclass本月有的天数
export function GetonlinerateDay(month, dayclass, list) {
    //筛选数据
    let data = list
    data = data.filter(val => val > -1)
    //添加百分比
    data = data.map(val => parseInt(val * 100))
    //创建时间数组
    let Time = []
    //时间排序
    dayclass.sort((a, b) => {
      return a.value - b.value
    })
    // 创建时间数据(月份数据每8小时一个值，每天3个点8-16-24)
    for (let i = 0, t = 0; i < ~~data.length / 3; t === 24 ? i++ : i) {
      let item = ''
      t === 24 ? t = 8 : t += 8
      let dateString = setDateEglish(dayclass[i].value)
      if(t === 8) {
        item = `${dayclass[i].value}${dateString}`
        Time.push(item)
        let index = Time.length - 1
        // 获取当前需要标记的下标数据
        let dataItem = data[index]
        data[index] = setData(dataItem)
      }else{
        item = `${dayclass[i].value}${dateString} : ${t}${i18n.t('lang.DateSelect.singlehour')}`
        Time.push(item)
      }
    }
    return { data, Time }
}

//筛选在线小时数据
export function GetonlinerateTime(list) {
  //筛选数据
  let data = list
  data = data.filter(val => val > -1)
  //添加百分比
  data = data.map(val => parseInt(val * 100))
  //创建时间数组
  let Time = []
  //创建时间数据(信号数据每天20分钟一个值,每小时20-40-60)
  for (let i = 0, t = 0; i < data.length / 3; t === 60 ? i++ : i) {
    t === 60 ? t = 20 : t = t + 20
    if(t === 20) {
      if(i< 10) {
        Time.push(`0${i}${i18n.t('lang.DateSelect.singlehour')}`)
      }else{
        Time.push(`${i}${i18n.t('lang.DateSelect.singlehour')}`)
      }
      let index = Time.length - 1
      let dataItem = data[index]
      data[index] = setData(dataItem)
    }else{
      if(i< 10) {
        Time.push(`0${i}${i18n.t('lang.DateSelect.singlehour')} : ${t}${i18n.t('lang.DateSelect.singleminute')}`)
      }else{
        Time.push(`${i}${i18n.t('lang.DateSelect.singlehour')} : ${t}${i18n.t('lang.DateSelect.singleminute')}`)
      }
    }
  }
  return { data, Time }
}
//筛选在线分钟数据
export function GetonlinerateTimeMinute(clock, list) {
    //创建时间数组
    let Time = []
        //筛选数据
    let data = list
    data = data.filter(val => val > -1)
        //添加百分比
    data = data.map(val => parseInt(val * 100))
        //创建时间数据(信号数据每小时5分钟一个值)
    for (let i = 5; i <= data.length * 5; i += 5) {
        //分钟 i===60 小时数clock+1 i='00'
        if (i >= 10) {
            let Clock;
            if (i === 60) {
                if (clock < 9) {
                    Clock = '0' + (Number(clock) + 1)
                } else {
                    Clock = String((Number(clock) + 1))
                }
            }
            Time.push(`${Clock||clock} : ${i===60?'00':i}`)
        } else {
            Time.push(`${clock} : 0${i}`)
        }
    }
    return { data, Time }
}
//筛选软件版本
export function GetSoftwareversion(List) {
    //软件版本
    let version = []
        //版本数量
    let counts = []
        //筛选软件版本与版本数量
    List.map((val, index) => {
            version.push(val.version)
            counts.push(val.counts)
        })
        //返回数据

    return { version, counts }
}

// 共用图形鼠标悬浮时显示的样式
export function tooltipFormate(params, statistisType) {
  let name = ''
  if(statistisType === 1) { // 统计类型为年时的格式
    if(params[0].name.includes(i18n.t('lang.DateSelect.st')) || params[0].name.includes(i18n.t('lang.DateSelect.rd')) 
       || params[0].name.includes(i18n.t('lang.DateSelect.nd')) || params[0].name.includes(i18n.t('lang.DateSelect.th'))){
        name = params[0].name
    }else{
      name = params[0].name + ' ' + '1' + i18n.t('lang.DateSelect.st')
    }
  }else if(statistisType === 2) { // 统计类型为月时
    if(!params[0].name.includes(':')) {
      name = `${params[0].name} : 8${i18n.t('lang.DateSelect.singlehour')}` 
    }else{
      name = name = params[0].name
    }
  }else if(statistisType === 3) { // 统计类型为日期时
    if(!params[0].name.includes(':')) {
      name = `${params[0].name} : 20${i18n.t('lang.DateSelect.singleminute')}` 
    }else{
      name = name = params[0].name
    }
  }else if(statistisType === 4) { // 统计类型为小时时
    if(!params[0].name.includes(':')) {
      name = `${params[0].name} : 05${i18n.t('lang.DateSelect.singleminute')}` 
    }else{
      name = name = params[0].name
    }
  }
  return name
}

// 共用图形x轴显示的样式
export function axisFormate(value, statistisType) {
  let val = ''
  if(statistisType === 1) { // 统计类型为年时的格式
    if(value.includes(i18n.t('lang.DateSelect.st')) || value.includes(i18n.t('lang.DateSelect.rd')) || 
    value.includes(i18n.t('lang.DateSelect.nd')) || value.includes(i18n.t('lang.DateSelect.th'))){
      val = ''
    }else{
      val = value
    }
    if(value === 'August') { // 英文八月比较特殊，本身月份里就含有st
      val = value
    }
  }else if(statistisType === 2 || statistisType === 3) {
    if(!value.includes(':')) {
      val = value
    }else{
      val = ''
    }
  }else if(statistisType === 4) {
    val = value
  }
  return val
}
// 图形的其他公共样式
export const otherStyle = {
  axisPointer: {
    type: 'cross',
    animation: false,
    label: {
      backgroundColor: '#ccc',
      borderColor: '#aaa',
      borderWidth: 1,
      shadowBlur: 0,
      shadowOffsetX: 0,
      shadowOffsetY: 0,
      color: '#222',
    }
  },
  dataZoom: [
    {
      show: true,
      xAxisIndex: [0],
      start: 0,
      end: 40
    }
  ],
  grid: {
    x: "0px",
    y: "20%",
    x2: "40px",
    containLabel: true
  },
}
// 在线率、信号单独设置特殊值样式
export function setData(dataItem) {
  let data = {
    value: dataItem,
    symbol: 'circle',
    symbolSize: 8,
    // 设置是否显示值，当值存在或大于0时才会显示
    label: {
      show: true,
      position: 'top',
      color: 'black',
      formatter: function (params) {
        let val = ''
        if(params.data.value) {
          val = params.data.value
        }else{
          val = ''
        }
        return val 
      },
    }
  }
  return data
}

// 日期对应的英文写法
export const dateEnglish = {
  'st': ['1', '21', '31'],
  'nd': ['2', '22'],
  'rd': ['3', '23'],//除了这三种剩下的都是th
  // 'th': ['4','5','6','7','8','9','10','11','12','13','14','15']
}
// 月份对应的英文
// 设置英文
export const setDateEglish = function(date) {
  let dateString = ''
  if(dateEnglish.st.includes(date.toString())){
    dateString = i18n.t('lang.DateSelect.st')
  }else if(dateEnglish.nd.includes(date.toString())){
    dateString = i18n.t('lang.DateSelect.nd')
  }else if(dateEnglish.rd.includes(date.toString())){
    dateString = i18n.t('lang.DateSelect.rd')
  }else{
    dateString = i18n.t('lang.DateSelect.th')
  }
  return dateString
}